import moment, { Moment } from 'moment'
import React, { useEffect, useState } from 'react'

import Spinner from '../../../App/Components/Spinner/Spinner'
import { useAppDispatch, useAppSelector } from '../../../App/Hooks/reduxHooks'
import { ITargetPeriod } from '../Client/ITarget'
import { getPersonRevenues, getPersonTargets } from '../Store/Actions'

import OverviewContent from './OverviewContent/OverviewContent'
import PeriodDatePicker from './PeriodDatePicker/PeriodDatePicker'
import { periodMapper } from './utils'

const Overview = () => {
  const dispatch = useAppDispatch()

  const [targets, personRevenues] = useAppSelector(state => {
    if (!state) return [null, []]
    return [state.hr.personTargets.list, state.hr.personTargets.personRevenues]
  })

  const [period, setPeriod] = useState<
    'weekly' | 'daily' | 'monthly' | 'yearly'
  >('monthly')
  const mappedPeriod = periodMapper(period)
  const [startDate, setStartDate] = useState<Moment>(
    moment().startOf(mappedPeriod),
  )
  const [endDate, setEndDate] = useState<Moment>(moment().endOf(mappedPeriod))

  useEffect(() => {
    if (startDate.isSameOrBefore(endDate)) {
      dispatch(getPersonRevenues(startDate, endDate))
    }

    if (null === targets) {
      dispatch(getPersonTargets())
    }
  }, [startDate, endDate])

  const onPeriodUpdate = (
    newPeriod: ITargetPeriod,
    newStartDate: Moment,
    newEndDate: Moment,
  ) => {
    if (newPeriod !== period) {
      setPeriod(newPeriod)
    }
    if (!newStartDate.isSame(startDate)) {
      setStartDate(newStartDate)
    }
    if (!newEndDate.isSame(endDate)) {
      setEndDate(newEndDate)
    }
  }

  if (null === targets || null === personRevenues) {
    return <Spinner />
  }

  return (
    <div>
      <PeriodDatePicker
        period={period}
        startDate={startDate}
        endDate={endDate}
        onDateUpdate={onPeriodUpdate}
      />

      {targets && (
        <OverviewContent
          period={period}
          targets={targets}
          personRevenues={personRevenues}
        />
      )}
    </div>
  )
}

export default Overview
